export const TOKEN_EXPIRED = 'MODAL/TOKEN_EXPIRED';
export const DELETE_REPORT = 'MODAL/DELETE_REPORT';
export const DELETE_CARDIO_VASCULAR_REPORT = 'MODAL/DELETE_CARDIO_VASCULAR_REPORT';
export const ACCEPT_USER_AGREEMENT = 'MODAL/ACCEPT_USER_AGREEMENT';
